import { openMsgModal, getMasterName } from '@/common/Common.js'
import PostalCodeService from './PostalCodeService'
import { MSG_TYPE, MASTER_CODE } from '@/common/const.js'

export function search(obj) {
  obj.searchCondition.prefectureName = getMasterName(
    MASTER_CODE.PREFECTURE,
    obj.searchCondition.prefectureCode
  )
  obj.$store.dispatch('init/setServiceLoading')
  PostalCodeService.search(obj.searchCondition)
    .then(
      (response) => {
        obj.tableItems = response.data.resultList
        if (obj.tableItems.length < 1) {
          // 警告モーダル表示
          openMsgModal(
            obj,
            MSG_TYPE.W,
            obj.$store.getters['init/getMessage']('YZ00MG907I')
          )
        }
      },
      (e) => {
        // エラーモーダル表示
        var msg
        if (e.response == undefined) {
          msg = obj.$store.getters['init/getMessage']('YZ00MG946E')
        } else {
          msg = e.response.data.message
        }
        openMsgModal(obj, MSG_TYPE.E, msg)
      }
    )
    .finally(() => {
      obj.$store.dispatch('init/setServiceUnLoading')
    })
}

export function clear(obj) {
  obj.searchCondition = obj.defaultSearchCondition()
  obj.tableItems = []
}
